import { __decorate, __metadata, __awaiter } from 'tslib';
import { Inject, InjectorService } from '@tencent/ioc';
import { ControllerService } from '../../services/controller/controller-service.js';
import { MiddlewareService } from '../../services/middleware/middleware-service.js';
import { WorkbenchSettingsService } from '../../services/settings/setting-service.js';
import { IStartUpService } from './start-up-service.interface.js';
import { BadgeService } from '../../services/badge/badge-service.js';
import { $logger } from '../logger/logger.js';
import { WorkbenchService } from '../../services/workbench/workbench-service.js';
import { FeatureService } from '../../services/feature/feature-service.js';
import { ConfigService } from '../../services/config/config-service.js';
import { InternalEventEmitter } from '../../services/event-emitter/internal-event-emitter.js';
import { MountService } from './mount-service.js';

/**
 * 用于加载 Workbench 的启动器
 *
 * @public
 */
class WorkbenchLoader {
    constructor() {
        this.version = 'b5bcbb9';
        const settings = WorkbenchSettingsService.getMetadata(this);
        if (settings) {
            this.settings.set(settings);
        }
    }
    callHook(key, ...args) {
        var _a;
        const { extensions = [] } = (_a = this.settings.mount) !== null && _a !== void 0 ? _a : {};
        extensions.forEach((extension) => {
            const instance = InjectorService.get(extension);
            if (instance[key]) {
                instance[key](...args);
            }
        });
        if (key in this) {
            return this[key](...args);
        }
        return 'not implemented';
    }
    start() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield this.callHook('$onInit');
                this.initServices();
                this.initMiddlewares();
                yield this.callHook('$onMount');
                yield this.mount();
                yield this.callHook('$afterControllersInit');
                yield this.attach();
                yield this.callHook('$onReady');
            }
            catch (e) {
                if (this.callHook('$onWorkbenchInitError', e) === 'not implemented') {
                    throw e;
                }
            }
        });
    }
    getComponent() {
        return this.startUpServive.getComponent();
    }
    initServices() {
        var _a;
        InjectorService.get(BadgeService);
        InjectorService.get(WorkbenchService);
        this.startUpServive.initServices(this.settings);
        InjectorService.get(ControllerService);
        InjectorService.get(ConfigService);
        InjectorService.get(InternalEventEmitter);
        if (this.settings.useLogger && this.settings.useLogger !== $logger) {
            $logger.use = this.settings.useLogger;
        }
        $logger.info(`workbenchVersion:${this.version}`);
        (_a = this.settings.mount.services) === null || _a === void 0 ? void 0 : _a.forEach(item => InjectorService.get(item));
    }
    initMiddlewares() {
        const middlewareService = InjectorService.get(MiddlewareService);
        this.startUpServive.initMiddlewares(middlewareService, this.settings);
        middlewareService.$onInit();
    }
    attach() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.startUpServive.attach(this.settings.container);
        });
    }
    mount() {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve) => {
                setTimeout(() => {
                    const controllerService = InjectorService.get(ControllerService);
                    controllerService.subscribeToControllerChange();
                    const featureService = InjectorService.get(FeatureService);
                    featureService.subscribeToFeatureChange();
                    const mountService = InjectorService.get(MountService);
                    mountService.subscribeToSettingServicesChange();
                    this.settings.addMountSettings(this.settings.mount);
                    resolve();
                }, 0);
            });
        });
    }
}
__decorate([
    Inject(),
    __metadata("design:type", WorkbenchSettingsService)
], WorkbenchLoader.prototype, "settings", void 0);
__decorate([
    Inject(IStartUpService),
    __metadata("design:type", Object)
], WorkbenchLoader.prototype, "startUpServive", void 0);

export { WorkbenchLoader };
//# sourceMappingURL=workbench-loader.js.map
